import React, { useEffect } from "react";
import {
  Drawer,
  AppBar,
  Box
} from "@mui/material";

import { WHITE_TEXT } from "../../color";
import { useStyles } from "./InternalStyle";
import ToolbarCompnent from "../Toolbar/ToolbarComponent";
import LoaderComponent from "../Loader/LoaderComponent";
import MenuListComponentNew from "../MenulistComponent/MenuListComponent";

export default function BarsOverlay(props) {

  const classes = useStyles();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [loader, setLoader] = React.useState(true);
  
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    if((props.menuDetails?.length > 0) || props.redirected) setLoader(false);
  }, []);

  return (
    <>
    {loader ? (
      <LoaderComponent />
    ) : (
    <Box sx={{ display: "flex" }}>
      <AppBar
        position="fixed"
        sx={{ width: `100%`, background: WHITE_TEXT , borderBottom:"2px solid #0075ff"}}
      >
        <ToolbarCompnent open={mobileOpen} setOpen={setMobileOpen} language={props.language} setLanguage={props.setLanguage}/>
      </AppBar>
      {
        !props.redirected && 
        (
          <>
      
      <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { marginTop: "4em" },
          }}
          className={classes.permanentDrawer}
        >
          <MenuListComponentNew hideMenu={setMobileOpen} menuDetails={props.menuDetails}/>
      </Drawer>
      <Drawer
        sx={{
          display: { xs: 'none', sm: 'block' },
          "& .MuiDrawer-paper": {  marginLeft:"0% !important",marginTop: "2rem" , width:"18%",paddingTop:"1rem" }
        }}
        className={classes.permanentDrawer}
        variant="permanent"
        // anchor="left"
      >
        <MenuListComponentNew menuDetails={props.menuDetails} />
      </Drawer>
      </>)
}
    </Box>
)}
</>
  );
}
